/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RestrictionStatus = {
    _11184809: '11184809',
    ACTIVE: 'ACTIVE',
    OVERRIDDEN: 'OVERRIDDEN',
    unknown_default_open_api: '11184809'
} as const;
export type RestrictionStatus = typeof RestrictionStatus[keyof typeof RestrictionStatus];


export function instanceOfRestrictionStatus(value: any): boolean {
    for (const key in RestrictionStatus) {
        if (Object.prototype.hasOwnProperty.call(RestrictionStatus, key)) {
            if (RestrictionStatus[key as keyof typeof RestrictionStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RestrictionStatusFromJSON(json: any): RestrictionStatus {
    return RestrictionStatusFromJSONTyped(json, false);
}

export function RestrictionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): RestrictionStatus {
    return json as RestrictionStatus;
}

export function RestrictionStatusToJSON(value?: RestrictionStatus | null): any {
    return value as any;
}

